import { render, staticRenderFns } from "./PatientAssistChat.vue?vue&type=template&id=7935ec0e"
import script from "./PatientAssistChat.vue?vue&type=script&lang=js"
export * from "./PatientAssistChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports